export const buildCampiOperatoriRequestParams = (campoId) => ({
    limit: 9999,
    offset: 0,
    filters: JSON.stringify({ COP_Id_Campi: campoId }),
});

export const normalizeCampiOperatoriResponse = (response) => {
    const rows = response?.records
        ?? response?.results
        ?? response?.data
        ?? response
        ?? [];

    if (!Array.isArray(rows)) {
        return [];
    }

    return rows
        .filter((row) => row && (row.COP_StatiRecord ?? 'A') !== 'D')
        .map((row) => ({
            COP_Id_CampiOperatori: row.COP_Id_CampiOperatori,
            COP_Operatore: row.COP_Operatore || '',
            COP_SuffissoFiltro: row.COP_SuffissoFiltro || '',
            COP_Sequenza: row.COP_Sequenza ?? 10,
        }))
        .sort((left, right) => (left.COP_Sequenza || 0) - (right.COP_Sequenza || 0));
};
